const APPROVAL_STATUSES = {
    NOT_SUBMITTED: 'not_submitted',
    WAITING_FOR_REVIEW: 'waiting_for_review',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
export default APPROVAL_STATUSES;
